
import headMeta from '@/constants/headMeta';
import routes from '@/constants/routes';

export default {
  data: () => ({
    loading: true,
    topic: 'general',
    fields: {
      general_questions: [],
      buyingandselling_questions: [],
      myabode_questions: [],
      pro_marketplace_questions: [],
      builder_question: [],
      uid: null,
    },
    mainView: {},
    mobileView: {},
  }),
  async fetch() {
    await this.getContent();
  },
  head() {
    return {
      title: this.fields.title,
      meta: [
        { hid: 'description', name: 'description', content: this.fields.description },
        { property: 'og:title', content: this.fields.title },
        { property: 'og:description', content: this.fields.description },
        { property: 'og:url', content: `${headMeta.domain}${routes.faq}` },
        { property: 'og:site_name', content: headMeta.siteName },
        { property: 'og:type', content: headMeta.type },
        { property: 'og:image', content: this.mainView.url },
      ],
    };
  },
  methods: {
    getContent() {
      return this.$prismic.client.getSingle('faq')
        .then((document) => {
          const { data } = document;
          // seo stuff:
          this.fields.title = data.meta_title;
          this.fields.description = data.meta_description;
          // page content:
          this.mainView = data.hero_image;
          this.mobileView = data.hero_image.mobile;
          // this.fields.hero_image = data.hero_image;
          this.fields.general_questions = data.general_questions;
          this.fields.buyingandselling_questions = data.buyingandselling_questions;
          this.fields.myabode_questions = data.myabode_questions;
          this.fields.pro_marketplace_questions = data.bodiverse_questions;
          this.fields.builder_questions = data.builder_questions;
          this.fields.uid = data.uid;
        });
    },
  },
};
